import React, { } from "react";
import HelpWindow from "./HelpWindow";
import { Typography } from "@mui/material";

export const Help_suggestionBoard = () => {
    return (
        <HelpWindow title="Suggestion Board" >
            <Typography variant="body1" gutterBottom>
                <br />
                Feel free to add suggestions, we will review any suggestion and add tag keywords before they show up on the board for other subscribers. <br />
                You can edit or remove any of your comments.<br />
                <br />
                Vote and comment on any suggestions and see how that suggestion is moving towards becoming a reality in the product.<br />
                Once your suggestion has been commented on or voted on it will not be able to be removed.<br />
                <br />
                Note: you can add an public alias/username to your subscriber under your profile, and it will show up on subsequent suggestions or comments<br />
                Anything offensive will be taken down immediately.<br />
            </Typography>
        </HelpWindow>
    )
}